import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverDelta4TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_DELTA4;
}

export default RiverDelta4TerrainTileEntity;
